import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import PDSButton from 'designSystem/components/PDSButton/PDSButton'
import PDSFlexBox from 'designSystem/components/PDSFlexBox/PDSFlexBox'
import PDSSeparator from 'designSystem/components/PDSSeparator/PDSSeparator'
import PDSText from 'designSystem/components/PDSText/PDSText'
import { COLOR } from 'designSystem/foundations/constants/color'
import { FONT_WEIGHT } from 'designSystem/foundations/constants/fontWeight'
import { SIZE } from 'designSystem/foundations/constants/size'

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

function ConfirmLiquidationModal({ isOpen, onClose, onConfirm }: Props) {
  return (
    <>
      <Modal isCentered isOpen={isOpen} onClose={onClose} size="sm">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader />
          <ModalCloseButton />
          <ModalBody paddingX={SIZE.s0}>
            <PDSFlexBox
              flexDirection="column"
              gap={SIZE.s16}
              paddingX={SIZE.s32}
            >
              <PDSText
                fontWeight={FONT_WEIGHT.semibold}
                color={COLOR.textPrimary}
                size="lg"
              >
                Confirm full liquidation?
              </PDSText>
              <PDSText
                color={COLOR.textSecondary}
                fontWeight={FONT_WEIGHT.regular}
                variant="p"
              >
                You have indicated a withdrawal amount equal to or greater than
                the total tradable value of this portfolio. As a result, Pave
                Pro will liquidate all tradable assets.
              </PDSText>

              <PDSText
                color={COLOR.textSecondary}
                fontWeight={FONT_WEIGHT.regular}
                variant="p"
              >
                Any cash equivalents, unsupported assets, or assets set as
                non-tradable will not be sold out of.
              </PDSText>
            </PDSFlexBox>
          </ModalBody>
          <PDSSeparator />
          <ModalFooter>
            <PDSFlexBox
              flexDirection="column"
              padding={SIZE.s32}
              gap={SIZE.s8}
              width="100%"
            >
              <PDSButton text="Continue" onClick={onConfirm} />

              <PDSButton text="Cancel" variant="tertiary" onClick={onClose} />
            </PDSFlexBox>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}
export default ConfirmLiquidationModal
